

import React from "react";
import { useLocation, Link } from "react-router-dom";
import logo from "../../assets/pageNotFound.png"; // Ensure the path is correct

function NotFound() {
  const location = useLocation();

  return (
    <div style={{ textAlign: "center", padding: "60px" }}>
      <img
        src={logo}
        alt="Page Not Found"
        style={{ height: "600px", width: "600px" }}
      />
      <h1 style={{ fontWeight: "bold", fontFamily: "'Arial', sans-serif" }}>
        Page Not Found
      </h1>
      <p style={{ fontWeight: "bold", fontSize: "25px ",fontFamily: "'Arial', sans-serif", color:"GrayText" }}>
        The page <code>{location.pathname}</code> does not exist.
      </p>
      <Link to="/" style={{ color: "blue", textDecoration: "underline" }}>
        Go to Login Page
      </Link>
    </div>
  );
}

export default NotFound;